/* VEXA regions build 2026-09-28-checkout-4 */
(function () {
  "use strict";

  var STORAGE_KEY = "vexa_delivery_region_v1";
  var SPECIAL_URL = "/pages/envios-especiales";
  var THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
  var mainPage = document.querySelector("[data-vexa-page]");
  var specialPage = document.querySelector("[data-vexa-special-page]");
  if (!mainPage && !specialPage) return;

  function readRegion() {
    try {
      var item = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
      if (!item || !item.value || Number(item.expires) < Date.now()) {
        localStorage.removeItem(STORAGE_KEY);
        return "";
      }
      return item.value;
    } catch (_) {
      return "";
    }
  }

  function saveRegion(value) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value: value, expires: Date.now() + THIRTY_DAYS }));
    } catch (_) {}
    document.cookie = "vexa_delivery_region=" + encodeURIComponent(value) + "; Max-Age=2592000; Path=/; SameSite=Lax";
  }

  function goSpecial(reason) {
    saveRegion("special");
    var target = SPECIAL_URL + (reason ? "?origen=" + encodeURIComponent(reason) : "");
    if (!specialPage && location.pathname !== SPECIAL_URL) location.assign(target);
  }

  function goPeninsula() {
    saveRegion("peninsula");
    if (specialPage) location.assign("/?region=peninsula");
  }

  function inSpecialCoordinates(latitude, longitude) {
    var boxes = [
      [27.4, 29.8, -18.8, -13.0],
      [38.4, 40.3, 0.8, 4.6],
      [35.82, 35.96, -5.44, -5.23],
      [35.23, 35.37, -3.03, -2.88]
    ];
    return boxes.some(function (box) {
      return latitude >= box[0] && latitude <= box[1] && longitude >= box[2] && longitude <= box[3];
    });
  }

  function detectGrantedLocation() {
    if (!mainPage || !navigator.permissions || !navigator.geolocation) return;
    navigator.permissions.query({ name: "geolocation" }).then(function (permission) {
      if (permission.state !== "granted") return;
      navigator.geolocation.getCurrentPosition(function (position) {
        if (inSpecialCoordinates(position.coords.latitude, position.coords.longitude)) goSpecial("ubicacion");
      }, function () {}, { maximumAge: 900000, timeout: 2500 });
    }).catch(function () {});
  }

  var query = new URLSearchParams(location.search);
  var requestedRegion = query.get("region");
  if (requestedRegion === "peninsula") saveRegion("peninsula");
  if (requestedRegion === "special") saveRegion("special");

  var current = readRegion();
  var country = String((mainPage || specialPage).dataset.visitorCountry || "ES").toUpperCase();
  var timezone = "";
  try { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ""; } catch (_) {}

  if (mainPage && !specialPage) {
    /* An explicit selector choice must be allowed to load the requested page.
       Purchase guards below still prevent COD from excluded regions. */
    if (requestedRegion !== "peninsula") {
      if (country && country !== "ES") {
        goSpecial("pais");
        return;
      }
      if (timezone === "Atlantic/Canary") {
        goSpecial("canarias");
        return;
      }
      if (current === "special") {
        goSpecial("preferencia");
        return;
      }
      detectGrantedLocation();
    }
  }

  document.querySelectorAll("[data-vexa-region-select]").forEach(function (select) {
    select.value = specialPage ? "special" : (readRegion() || "peninsula");
    select.addEventListener("change", function () {
      if (select.value === "special") goSpecial("selector");
      else goPeninsula();
    });
  });

  /* The special template renders checkout CTAs as real links. Do not intercept
     those clicks here: the normal browser navigation is the most reliable
     fallback on mobile browsers and the product script keeps each href synced
     with the selected kit. */
  if (specialPage) return;

  if (!mainPage || specialPage) return;

  function normalize(value) {
    return String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  }

  function formNeedsSpecialRoute(form) {
    if (!form) return false;
    var data = new FormData(form);
    var postal = String(data.get("zip") || "").replace(/\D/g, "").slice(0, 2);
    if (["07", "35", "38", "51", "52"].indexOf(postal) !== -1) return true;
    var text = normalize([data.get("province"), data.get("city"), data.get("address1"), data.get("address2")].join(" "));
    return ["baleares", "balears", "mallorca", "menorca", "ibiza", "eivissa", "formentera", "canarias", "tenerife", "gran canaria", "lanzarote", "fuerteventura", "gomera", "hierro", "graciosa", "ceuta", "melilla"].some(function (term) {
      return text.indexOf(term) !== -1;
    });
  }

  document.addEventListener("click", function (event) {
    var action = event.target.closest("[data-cod-open], [data-online-checkout]");
    if (!action) return;
    if (readRegion() !== "special" && country === "ES" && timezone !== "Atlantic/Canary") return;
    event.preventDefault();
    event.stopImmediatePropagation();
    goSpecial("compra");
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target.closest("[data-cod-form]");
    if (!form || !formNeedsSpecialRoute(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    goSpecial("direccion");
  }, true);
})();
